import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import logohtml from "./../../images/icons/html.gif";
import logocss from "./../../images/icons/css.gif";
import bootstrap from "./../../images/icons/bootstrap.gif";
import reactbootstrap from "./../../images/icons/react-bootstrap.png";
import logoJavaScript from "./../../images/icons/javascript.gif";
import JavaScript from "./../../images/icons/js.webp";
import logoReact from "./../../images/icons/react-native.gif";
import react from "./../../images/icons/react.gif";
import mui from "./../../images/icons/mui.png";
import logoReact2 from "./../../images/icons/physics.gif";
import logoSettings from "./../../images/icons/settings.gif";
import firebase from "./../../images/icons/firebase.gif";
import logoGear from "./../../images/icons/gear.gif";
import logoLab from "./../../images/icons/gitlab.gif";
import logogit from "./../../images/icons/git.gif";
import logogithub from "./../../images/icons/github.gif";
import logochrome from "./../../images/icons/chrome.gif";
import logonet from "./../../images/icons/netlify.png";
import logonode from "./../../images/icons/node.gif";
import logomongo from "./../../images/icons/mongodb.png";
import logoex from "./../../images/icons/express.png";
import logoType from "./../../images/icons/typescript.png";
import logotail from "./../../images/icons/tailwind.png";
import logoSass from "./../../images/icons/sass.png";
import logoes6 from "./../../images/icons/ecmascript6.png";
import logoskill from "./../../images/icons/developer-flat.gif";
import logoRest from "./../../images/icons/rest-api.gif";
import "./Skill.css";

const Skill = () => {
  return (
    <div className="pb-5">
      <div>
        <h3 className="text-center mt-5 mb-5 skill d-flex justify-content-center align-items-center">
          <img className="me-1" src={logoGear} width="50px" alt="" />
          My Skills
          <img className="ms-1" src={logoGear} width="50px" alt="" />
        </h3>
      </div>
      <Container className="border-1">
        <Row
          xs={2}
          md={4}
          className="mb-2 d-flex justify-content-center align-items-center gx-3 gy-3 pb-3 skill"
        >
          <Col className="">
            <li className="skill_first d-flex justify-content-center align-items-center">
              <img className="me-1" src={logohtml} width="30px" alt="" />
              HTML5
            </li>
          </Col>
          <Col className="">
            <li className="skill_first d-flex justify-content-center align-items-center">
              <img className="me-1" src={logocss} width="30px" alt="" />
              CSS3
            </li>
          </Col>
          <Col className="">
            <li className="skill_first d-flex justify-content-center align-items-center">
              <img className="me-1" src={bootstrap} width="30px" alt="" />
              BootStrap
            </li>
          </Col>
          <Col className="">
            <li className="skill_first d-flex justify-content-center align-items-center">
              <img className="me-1" src={logoJavaScript} width="30px" alt="" />
              JavaScript
            </li>
          </Col>
          <Col className="">
            <li className="skill_first d-flex justify-content-center align-items-center">
              <img className="me-1" src={logoes6} width="30px" alt="" />
              {/* <i class="fa-brands fa-js-square me-1 icon_correction"></i> */}
              Es6
            </li>
          </Col>
          <Col className="">
            <li className="skill_first d-flex justify-content-center align-items-center">
              <img className="me-1" src={logoRest} width="32px" alt="" />
              Restfull Api
            </li>
          </Col>
          <Col className="">
            <li className="skill_first d-flex justify-content-center align-items-center">
              <img className="me-1" src={logoJavaScript} width="30px" alt="" />
              Dom manipulation
            </li>
          </Col>
          <Col className="">
            <li className="skill_first d-flex justify-content-center align-items-center">
              <img className="me-1" src={react} width="30px" alt="" />
              React
            </li>
          </Col>
          <Col className="">
            <li className="skill_first d-flex justify-content-center align-items-center">
              <img
                className="me-1"
                src={reactbootstrap}
                width="30px"
                height="30px"
                alt=""
              />
              React BootStrap
            </li>
          </Col>
          <Col className="">
            <li className="skill_first d-flex justify-content-center align-items-center">
              <img className="me-1" src={mui} width="30px" alt="" />
              Material Ui (Basic)
            </li>
          </Col>
          <Col className="">
            <li className="skill_first d-flex justify-content-center align-items-center">
              <img className="me-1" src={logoReact2} width="30px" alt="" />
              React Router
            </li>
          </Col>
          <Col className="">
            <li className="skill_first d-flex justify-content-center align-items-center">
              <img
                className="me-1"
                src={firebase}
                width="30px"
                height="30px"
                alt=""
              />
              Firebase Authenticate
            </li>
          </Col>
          <Col className="">
            <li className="skill_first d-flex justify-content-center align-items-center">
              <img
                className="me-1"
                src={logomongo}
                width="31px"
                height="31px"
                alt=""
              />
              MongoDB (Basic)
            </li>
          </Col>
          <Col className="">
            <li className="skill_first d-flex justify-content-center align-items-center">
              <img className="me-1" src={logonode} width="30px" alt="" />
              Node.js (Basic)
            </li>
          </Col>
          <Col className="">
            <li className="skill_first d-flex justify-content-center align-items-center">
              <img className="me-1" src={logoex} width="30px" alt="" />
              Express.js
            </li>
          </Col>
          <Col className="">
            <li className="skill_first d-flex justify-content-center align-items-center">
              <img
                className="me-1"
                src={logogit}
                width="33px"
                height="33px"
                alt=""
              />
              Git
            </li>
          </Col>
          <Col className="">
            <li className="skill_first d-flex justify-content-center align-items-center">
              <img
                className="me-1"
                src={logogithub}
                width="31px"
                height="31px"
                alt=""
              />
              GitHub
            </li>
          </Col>
          <Col className="">
            <li className="skill_first d-flex justify-content-center align-items-center">
              <img className="me-1" src={logochrome} width="30px" alt="" />
              Chrome DevTool
            </li>
          </Col>
          <Col className="">
            <li className="skill_first d-flex justify-content-center align-items-center">
              <img className="me-1" src={logonet} width="30px" alt="" />
              Netlify Deploy
            </li>
          </Col>
          <Col className="">
            <li className="skill_first d-flex justify-content-center align-items-center">
              <img className="me-1" src={logoLab} width="30px" alt="" />
              Gitlab
            </li>
          </Col>
          <Col className="">
            <li className="skill_first d-flex justify-content-center align-items-center">
              <img className="me-1" src={logoType} width="28px" alt="" />
              Typescript
            </li>
          </Col>
          <Col className="">
            <li className="skill_first d-flex justify-content-center align-items-center">
              <img
                className="me-1"
                src={logoSass}
                width="30px"
                height="29px"
                alt=""
              />
              Sass
            </li>
          </Col>
          <Col className="">
            <li className="skill_first d-flex justify-content-center align-items-center">
              <img className="me-1" src={logotail} width="30px" alt="" />
              Tailwind
            </li>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Skill;
